// extracted by mini-css-extract-plugin
export default {"skinRefine":"SkinRefine_skinRefine__m896a","title":"SkinRefine_title__BMy2b","switch":"SkinRefine_switch__Wdai8"};